import { __extends, __values } from "tslib";
import React, { Component } from 'react';
import { cloneDeep, uniq } from 'lodash';
import { FilterHelper } from './utils/FilterHelper';
import { CheckboxInput } from './form/CheckboxInput';
import { AccordionPanel } from './AccordionPanel';
import { AmountFilter } from './AmountFilter';
var FilterComponent = /** @class */ (function (_super) {
    __extends(FilterComponent, _super);
    function FilterComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { initialized: false, searchTerm: '', styles: [] };
        return _this;
    }
    FilterComponent.prototype.componentDidMount = function () {
        if (!this.state.initialized && this.props.filter) {
            this.initFilters(this.props.filter, this.props.styles);
        }
    };
    FilterComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
        if ((!this.state.initialized || this.props.styles.length !== prevProps.styles.length) && this.props.filter) {
            this.initFilters(this.props.filter, this.props.styles);
        }
    };
    FilterComponent.prototype.componentWillUnmount = function () {
        this.setState({ initialized: false });
    };
    FilterComponent.getDerivedStateFromProps = function (props, state) {
        if (props.styles !== state.styles) {
            return {
                styles: props.styles,
            };
        }
        return null;
    };
    FilterComponent.prototype.initFilters = function (filter, styles) {
        var e_1, _a;
        var newFilter = cloneDeep(filter);
        if (this.props.productGroupConfig) {
            for (var groupName in this.props.productGroupConfig) {
                var _loop_1 = function (rule) {
                    var includeStyles = styles.filter(function (style) { return style.productGroup.toLowerCase() === rule.include.group.toLowerCase(); });
                    var _loop_2 = function (delta) {
                        var ORpropety = rule.include.ORproperties[delta];
                        // @ts-ignore
                        var local = includeStyles.filter(function (style) { return style[Object.keys(ORpropety)[0]] === true; });
                        var _loop_3 = function (i) {
                            var index = styles.findIndex(function (style) { return style.masterId === local[i].masterId && style.colorCode === local[i].colorCode; });
                            if (styles[index]) {
                                var cloned = styles[index].subCategories;
                                cloned.push(groupName);
                                styles[index].subCategories = uniq(cloned);
                            }
                        };
                        for (var i in local) {
                            _loop_3(i);
                        }
                    };
                    // console.log(rule.include.ORproperties, 'rule.include.ORproperties')
                    for (var delta in rule.include.ORproperties) {
                        _loop_2(delta);
                    }
                };
                try {
                    for (var _b = (e_1 = void 0, __values(this.props.productGroupConfig[groupName])), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var rule = _c.value;
                        _loop_1(rule);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
        newFilter.collections = FilterHelper.hydrateCollections(styles);
        newFilter.seasons = FilterHelper.hydrateSeasons(styles);
        newFilter.productGroups = FilterHelper.hydrateProductGroups(styles);
        newFilter.deliveryWindows = FilterHelper.hydrateDeliveryWindows(styles);
        if (!this.props.collectionName) {
            newFilter.productCategories = FilterHelper.hydrateProductCategories(styles);
        }
        else {
            newFilter.productCategories = FilterHelper.hydrateProductCategoriesByCollectionSort(styles, this.props.collectionName);
        }
        newFilter.sustainability = FilterHelper.hydrateSustainability(styles);
        this.props.applyFilter(newFilter);
        this.setState({
            initialized: true
        });
    };
    FilterComponent.prototype.onFilterSelectionSeason = function (event) {
        var selectedSeason = event.currentTarget.value;
        var selectedSeasonIsActive = event.currentTarget.checked;
        this.changeActiveFilters('seasons', selectedSeason, selectedSeasonIsActive);
    };
    FilterComponent.prototype.onFilterSelectionProductGroup = function (event) {
        var selectedProductGroup = event.currentTarget.value;
        var selectedProductGroupIsActive = event.currentTarget.checked;
        this.changeActiveFilters('productGroups', selectedProductGroup, selectedProductGroupIsActive);
    };
    FilterComponent.prototype.onFilterSelectionVisiblePrices = function (event) {
        var visiblePrice = event.currentTarget.value;
        var selectedPriceVisible = event.currentTarget.checked;
        this.changeActiveFilters('visiblePrices', visiblePrice, selectedPriceVisible);
    };
    FilterComponent.prototype.onChangeMinimumAvailable = function (value) {
        this.changeActiveFilters('mimimumAvailable', value, true);
    };
    FilterComponent.prototype.onFilterSelectionSustainability = function (event) {
        var selected = event.currentTarget.value;
        var selectedIsActive = event.currentTarget.checked;
        this.changeActiveFilters('sustainability', selected, selectedIsActive);
    };
    FilterComponent.prototype.onFilterSelectionDeliveryWindow = function (event) {
        var selectedDeliveryWindow = event.currentTarget.value;
        var selectedDeliveryWindowIsActive = event.currentTarget.checked;
        this.changeActiveFilters('deliveryWindows', selectedDeliveryWindow, selectedDeliveryWindowIsActive);
    };
    FilterComponent.prototype.onFilterSelectionProductCategory = function (event) {
        var selectedProdoctCategory = event.currentTarget.value;
        var selectedProdoctCategoryWindowIsActive = event.currentTarget.checked;
        this.changeActiveFilters('productCategories', selectedProdoctCategory, selectedProdoctCategoryWindowIsActive);
    };
    FilterComponent.prototype.onFilterSelectionCollection = function (event) {
        var selectedCollection = event.currentTarget.value;
        var selectedCollectionIsActive = event.currentTarget.checked;
        this.changeActiveFilters('collections', selectedCollection, selectedCollectionIsActive);
    };
    FilterComponent.prototype.changeActiveFilters = function (filterType, filterValue, isActive) {
        var newFilter = Object.assign({}, this.props.filter);
        if (!newFilter)
            return;
        var tempResult;
        switch (filterType) {
            case 'collections':
                if (isActive) {
                    newFilter.activeFilters.collections.push(filterValue);
                }
                else {
                    var filterTypeIndex = newFilter.activeFilters.collections.indexOf(filterValue);
                    newFilter.activeFilters.collections.splice(filterTypeIndex, 1);
                }
                break;
            case 'seasons':
                if (isActive) {
                    newFilter.activeFilters.seasons.push(filterValue);
                }
                else {
                    var filterTypeIndex = newFilter.activeFilters.seasons.indexOf(filterValue);
                    newFilter.activeFilters.seasons.splice(filterTypeIndex, 1);
                }
                break;
            case 'deliveryWindows':
                if (isActive) {
                    newFilter.activeFilters.deliveryWindows.push(filterValue);
                }
                else {
                    var filterTypeIndex = newFilter.activeFilters.deliveryWindows.indexOf(filterValue);
                    newFilter.activeFilters.deliveryWindows.splice(filterTypeIndex, 1);
                }
                break;
            case 'sustainability':
                if (isActive && newFilter.activeFilters.sustainability) {
                    newFilter.activeFilters.sustainability.push(filterValue);
                }
                else {
                    if (newFilter.activeFilters.sustainability) {
                        var filterTypeIndex = newFilter.activeFilters.sustainability.indexOf(filterValue);
                        newFilter.activeFilters.sustainability.splice(filterTypeIndex, 1);
                    }
                }
                break;
            case 'productGroups':
                if (isActive) {
                    newFilter.activeFilters.productGroups.push(filterValue);
                }
                else {
                    var filterTypeIndex = newFilter.activeFilters.productGroups.indexOf(filterValue);
                    newFilter.activeFilters.productGroups.splice(filterTypeIndex, 1);
                }
                var cloned = cloneDeep(newFilter);
                cloned.activeFilters.productCategories = [];
                tempResult = FilterHelper.resultByFilter(cloned, this.props.styles);
                if (!this.props.collectionName) {
                    newFilter.productCategories = FilterHelper.hydrateProductCategories(tempResult);
                }
                else {
                    newFilter.productCategories = FilterHelper.hydrateProductCategoriesByCollectionSort(tempResult, this.props.collectionName);
                }
                break;
            case 'productCategories':
                if (isActive) {
                    newFilter.activeFilters.productCategories.push(filterValue);
                }
                else {
                    var filterTypeIndex = newFilter.activeFilters.productCategories.indexOf(filterValue);
                    newFilter.activeFilters.productCategories.splice(filterTypeIndex, 1);
                }
                break;
            case 'mimimumAvailable':
                newFilter.activeFilters.minimumAvailable = +filterValue;
                break;
            case 'visiblePrices':
                if (isActive && newFilter.activeFilters.visiblePrices) {
                    newFilter.activeFilters.visiblePrices.push(filterValue);
                }
                else {
                    if (newFilter.activeFilters.visiblePrices) {
                        var filterTypeIndex = newFilter.activeFilters.visiblePrices.indexOf(filterValue);
                        newFilter.activeFilters.visiblePrices.splice(filterTypeIndex, 1);
                    }
                }
                break;
        }
        this.props.applyFilter(newFilter);
    };
    FilterComponent.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "filter-sidebar " + (this.props.showFilter ? "--is-active" : "--is-hidden") },
            this.props.showGoBack && React.createElement("div", { className: "filter-sidebar__go-back", onClick: function () { return _this.props.onClickBack && _this.props.onClickBack(); } }, "Back to Dashboard"),
            this.props.filters.indexOf('collections') !== -1 && React.createElement(AccordionPanel, { heading: "Collections", defaultClosed: this.props.useDefaultOpen && this.props.defaults ? this.props.defaults.indexOf('collections') !== -1 : true },
                React.createElement("div", { className: "a-filter-facet-group" }, (this.props.filter && this.props.filter.collections
                    && this.props.filter.collections.map(function (collection) {
                        return _this.props.filter && !!collection && (React.createElement("div", { className: "a-filter-facet", key: collection },
                            React.createElement(CheckboxInput, { name: collection, title: collection, handleChange: _this.onFilterSelectionCollection.bind(_this), value: collection, checked: _this.props.filter.activeFilters.collections.indexOf(collection) !== -1 })));
                    })))),
            this.props.filters.indexOf('product_groups') !== -1 &&
                React.createElement(AccordionPanel, { heading: "Product Groups", defaultClosed: this.props.useDefaultOpen && this.props.defaults ? this.props.defaults.indexOf('productGroups') !== -1 : true },
                    React.createElement("div", { className: "a-filter-facet-group" }, (this.props.filter && this.props.filter.productGroups
                        && this.props.filter.productGroups.map(function (productGroupName) {
                            return _this.props.filter && !!productGroupName && (React.createElement("div", { className: "a-filter-facet", key: productGroupName },
                                React.createElement(CheckboxInput, { name: productGroupName, title: productGroupName, handleChange: _this.onFilterSelectionProductGroup.bind(_this), value: productGroupName, checked: _this.props.filter.activeFilters.productGroups.indexOf(productGroupName) !== -1 })));
                        })))),
            this.props.filters.indexOf('product_categories') !== -1 &&
                React.createElement(AccordionPanel, { heading: "Product Categories", defaultClosed: this.props.useDefaultOpen && this.props.defaults ? this.props.defaults.indexOf('productCategories') !== -1 : true },
                    React.createElement("div", { className: "a-filter-facet-group" }, (this.props.filter && this.props.filter.productCategories
                        && this.props.filter.productCategories.map(function (productCategoryName) {
                            return _this.props.filter && !!productCategoryName && (React.createElement("div", { className: "a-filter-facet", key: productCategoryName },
                                React.createElement(CheckboxInput, { name: productCategoryName, title: productCategoryName, handleChange: _this.onFilterSelectionProductCategory.bind(_this), value: productCategoryName, checked: _this.props.filter.activeFilters.productCategories.indexOf(productCategoryName) !== -1 })));
                        })))),
            this.props.filters.indexOf('delivery_windows') !== -1 &&
                React.createElement(AccordionPanel, { heading: "Delivery Windows", defaultClosed: this.props.useDefaultOpen && this.props.defaults ? this.props.defaults.indexOf('deliveryWindows') !== -1 : true },
                    React.createElement("div", { className: "a-filter-facet-group" }, (this.props.filter && this.props.filter.deliveryWindows
                        && this.props.filter.deliveryWindows.map(function (deliveryWindowName) {
                            return _this.props.filter && !!deliveryWindowName && (React.createElement("div", { className: "a-filter-facet", key: deliveryWindowName },
                                React.createElement(CheckboxInput, { name: deliveryWindowName, title: deliveryWindowName, handleChange: _this.onFilterSelectionDeliveryWindow.bind(_this), value: deliveryWindowName, checked: _this.props.filter.activeFilters.deliveryWindows.indexOf(deliveryWindowName) !== -1 })));
                        })))),
            this.props.filters.indexOf('sustainability') !== -1 &&
                React.createElement(AccordionPanel, { heading: "Sustainability", defaultClosed: this.props.useDefaultOpen && this.props.defaults ? this.props.defaults.indexOf('sustainability') !== -1 : true },
                    React.createElement("div", { className: "a-filter-facet-group" }, (this.props.filter && this.props.filter.sustainability
                        && this.props.filter.sustainability.map(function (type) {
                            return _this.props.filter && !!type && (React.createElement("div", { className: "a-filter-facet", key: type },
                                React.createElement(CheckboxInput, { name: type, title: type.toUpperCase().replace('_', ' '), handleChange: _this.onFilterSelectionSustainability.bind(_this), value: type, checked: !!_this.props.filter.activeFilters.sustainability &&
                                        _this.props.filter.activeFilters.sustainability.indexOf(type) !== -1 })));
                        })))),
            this.props.filters.indexOf('minimum_available') !== -1 && React.createElement(AccordionPanel, { heading: "Minimum available", defaultClosed: true },
                React.createElement("div", { className: "a-filter-facet-group" },
                    React.createElement(AmountFilter, { apply: this.onChangeMinimumAvailable.bind(this) }))),
            this.props.filters.indexOf('visible_prices') !== -1 &&
                React.createElement(AccordionPanel, { heading: "Price Filter", defaultClosed: true },
                    React.createElement("div", { className: "a-filter-facet-group" }, (this.props.filter && this.props.filter.visiblePrices
                        && this.props.filter.visiblePrices.map(function (name) {
                            return _this.props.filter && !!name && (React.createElement("div", { className: "a-filter-facet", key: name },
                                React.createElement(CheckboxInput, { name: name, title: name, handleChange: _this.onFilterSelectionVisiblePrices.bind(_this), value: name.replace('_', ' '), checked: !!_this.props.filter.activeFilters.visiblePrices && _this.props.filter.activeFilters.visiblePrices.indexOf(name) !== -1 })));
                        }))))));
    };
    return FilterComponent;
}(Component));
export { FilterComponent };
//# sourceMappingURL=FilterComponent.js.map